import type { Plant } from '../types/plant';
import type { Tutorial } from '../types/tutorial';

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbSource {
  type: 'plants' | 'collection' | 'garden';
  collectionName?: string;
  collectionSlug?: string;
}

export function generatePlantBreadcrumb(plant: Plant, source?: BreadcrumbSource): BreadcrumbItem[] {
  const basePath = [{ label: 'Home', path: '/' }];

  if (source?.type === 'collection' && source.collectionName && source.collectionSlug) {
    return [
      ...basePath,
      { label: 'Collections', path: '/collections' },
      { label: source.collectionName, path: `/collections/${source.collectionSlug}` },
      { label: plant.name, path: `/plants/${plant.id}` }
    ];
  } else if (source?.type === 'garden') {
    return [
      ...basePath,
      { label: 'My Garden', path: '/my-garden' },
      { label: plant.name, path: `/plants/${plant.id}` }
    ];
  }

  // Default path through plants list
  return [
    ...basePath,
    { label: 'Plants', path: '/plants' },
    { label: plant.name, path: `/plants/${plant.id}` }
  ];
}

export function generatePlantsListBreadcrumb(): BreadcrumbItem[] {
  return [
    { label: 'Home', path: '/' },
    { label: 'Plants', path: '/plants' }
  ];
}

export function generateMyGardenBreadcrumb(): BreadcrumbItem[] {
  return [
    { label: 'Home', path: '/' },
    { label: 'My Garden', path: '/my-garden' }
  ];
}

export function generateCartBreadcrumb(): BreadcrumbItem[] {
  return [
    { label: 'Home', path: '/' },
    { label: 'Shopping Cart', path: '/cart' }
  ];
}

export function generateTutorialsHomeBreadcrumb(): BreadcrumbItem[] {
  return [
    { label: 'Home', path: '/' },
    { label: 'Tutorials', path: '/tutorials' }
  ];
}

export function generateTutorialBreadcrumb(tutorial: Tutorial): BreadcrumbItem[] {
  return [
    { label: 'Home', path: '/' },
    { label: 'Tutorials', path: '/tutorials' },
    { label: tutorial.title, path: `/tutorials/${tutorial.slug}` }
  ];
}

export function generateTutorialCategoryBreadcrumb(categoryName: string, categorySlug: string): BreadcrumbItem[] {
  return [
    { label: 'Home', path: '/' },
    { label: 'Tutorials', path: '/tutorials' },
    { label: categoryName, path: `/tutorials/category/${categorySlug}` }
  ];
}